import { Notification } from "element-ui";
import Cookies from "js-cookie";
import * as CryptoJS from "crypto-js";

const TOKEN = "token";

export function getToken() {
  return window.localStorage.getItem(TOKEN);
}

export function setToken(token) {
  Cookies.set(TOKEN, token);
  return window.localStorage.setItem(TOKEN, token);
}

export function removeToken() {
  Cookies.remove(TOKEN);
  return window.localStorage.removeItem(TOKEN);
}

export function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle}-山西中药材产业网`;
  }
  return "山西中药材产业网";
}

// DES加密
export const encryptByDES = (message, key) => {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export function daodi123(val) {
  return encryptByDES(val, "JAPhbQav");
}

const CLIENT_VERSION = "web_client_version";
// 校验当前版本是否需要刷新
export function verifyCurrentVersion(response) {
  const client_version = localStorage.getItem(CLIENT_VERSION);
  const serve_version = response.headers.client_version;

  // 如果没有版本号，或者版本号一致，无事发生。
  if (!serve_version || client_version === serve_version) return;

  localStorage.setItem(CLIENT_VERSION, serve_version);

  Notification.info({
    title: "日常维护",
    message: "检测到网站已更新，5秒后将自动刷新。",
    position: "bottom-right",
    duration: 5000,
  });

  setTimeout(() => {
    window.location.reload();
  }, 5500);
}
